import React from 'react';
import styled from 'styled-components';
import { SCALE } from '../../utils/constants';
import { Anchor, alto, arendtBlue, white, wildSand, HorizontalRule } from '@parchment/atoms';
const noop = () => undefined;
export const AnchorList = _ref => {
  let {
    items = [],
    onItemClick = noop,
    scale = SCALE.medium,
    center = true,
    ghost = false,
    className
  } = _ref;
  const handleClick = (e, index) => {
    e.preventDefault();
    onItemClick(index, items);
  };
  return /*#__PURE__*/React.createElement(OuterContainer, {
    ghost: ghost,
    className: className
  }, items.map((item, index) => /*#__PURE__*/React.createElement(AnchorWrapper, {
    center: center,
    key: index
  }, /*#__PURE__*/React.createElement(AnchorLink, {
    scale: scale,
    onClick: e => handleClick(e, index)
  }, item), index + 1 !== items.length && /*#__PURE__*/React.createElement(HorizontalLine, null))));
};
const OuterContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "AnchorList__OuterContainer",
  componentId: "rwjate-0"
})(["box-shadow:inset 0 0 0 1px ", ";background-color:", ";padding:20px;display:flex;align-content:center;flex-wrap:wrap;"], alto, props => props.ghost ? white : wildSand);
const AnchorWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AnchorList__AnchorWrapper",
  componentId: "rwjate-1"
})(["flex-basis:100%;flex-wrap:wrap;padding:0 8px;display:flex;justify-content:", ";"], props => props.center ? 'center' : 'left');
const AnchorLink = /*#__PURE__*/styled(Anchor).withConfig({
  displayName: "AnchorList__AnchorLink",
  componentId: "rwjate-2"
})(["font-size:", ";color:", ""], props => ({
  default: '16px',
  small: '13px',
  medium: '16px',
  large: '20px'
})[props.scale], arendtBlue);
const HorizontalLine = /*#__PURE__*/styled(HorizontalRule).withConfig({
  displayName: "AnchorList__HorizontalLine",
  componentId: "rwjate-3"
})(["margin:8px 0;flex-basis:100%;"]);